import { render, staticRenderFns } from "./NotificationRow.vue?vue&type=template&id=18977820&scoped=true&"
import script from "./NotificationRow.vue?vue&type=script&lang=js&"
export * from "./NotificationRow.vue?vue&type=script&lang=js&"
import style0 from "./NotificationRow.vue?vue&type=style&index=0&id=18977820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18977820",
  null
  
)

export default component.exports